import { render, staticRenderFns } from "./DelMappingDomain.vue?vue&type=template&id=51400955&scoped=true"
import script from "./DelMappingDomain.vue?vue&type=script&lang=js"
export * from "./DelMappingDomain.vue?vue&type=script&lang=js"
import style0 from "./DelMappingDomain.vue?vue&type=style&index=0&id=51400955&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51400955",
  null
  
)

export default component.exports